<template>
  <v-toolbar class="my-md-auto" elevation="0"  >
    <slot name="left"></slot>
    <v-spacer />
    <div v-if="hasAccess">
      
      <v-btn
        v-if="handleBack"
        color=""
        class="ml-sm-2"
        @click="backItem"
      >
        {{ $t('global.back')}}
      </v-btn>
      <slot name="right"></slot>
      <v-btn
        v-if="handleReset"
        color=""
        class="ml-sm-2"
        @click="resetItem"
      >
        {{ $t('global.reset')}}
      </v-btn>
      <v-btn
        v-if="handleDelete"
        color="error"
        class="ml-sm-2"
        @click="confirmDelete = true"
      >
        {{ $t('global.delete')}}
      </v-btn>
      <v-btn
        v-if="handleEdit"
        :loading="isLoading"
        class="ml-sm-2"
        color="primary"
        @click="editItem"
      >
        {{ $t('global.update')}}
      </v-btn>
      <v-btn
        v-if="handleSubmit"
        :loading="isLoading"
        class="ml-sm-2"
        color="primary"
        @click="submitItem"
      >
        {{ $t('global.submit')}}
      </v-btn>

      <v-btn v-if="handleAdd" color="primary" rounded @click="addItem">
        <v-icon>mdi-plus-circle</v-icon>
      </v-btn>
    </div>
    <ConfirmDelete
      v-if="handleDelete"
      :visible="confirmDelete"
      :handle-delete="handleDelete"
      @close="confirmDelete = false"
    />
  </v-toolbar>
</template>

<script>
import ConfirmDelete from './ConfirmDelete';

export default {
  name: 'Toolbar',
  components: {
    ConfirmDelete
  },
  data() {
    return {
      confirmDelete: false
    };
  },
  props: {
    handleSubmit: {
      type: Function,
      required: false
    },
    handleEdit: {
      type: Function,
      required: false
    },
    handleReset: {
      type: Function,
      required: false
    },
    handleBack: {
      type: Function,
      required: false
    },
    handleDelete: {
      type: Function,
      required: false
    },
    handleAdd: {
      type: Function,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: () => false
    },
    hasAccess: {
      type: Boolean,
      required: false,
      default: () => true
    }
  },
  methods: {
    addItem() {
      if (this.handleAdd) {
        this.handleAdd();
      }
    },
    editItem() {
      if (this.handleEdit) {
        this.handleEdit();
      }
    },
    submitItem() {
      if (this.handleSubmit) {
        this.handleSubmit();
      }
    },
    resetItem() {
      if (this.handleReset) {
        this.handleReset();
      }
    },
    backItem() {
      if (this.handleBack) {
        this.handleBack();
      }
    }
  }
};
</script>
